import { render, staticRenderFns } from "./AdminBlackIcon.vue?vue&type=template&id=77ca2309&"
import script from "./AdminBlackIcon.vue?vue&type=script&lang=js&"
export * from "./AdminBlackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports